import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Segment, Header, Form, Grid, Button, Input } from 'semantic-ui-react';
import styles from '../App.module.scss';

import { submitContactForm, recordQuizResult } from 'sagas/index.jsx';
import { useEffect } from 'react';
import { useRouteMatch } from 'react-router-dom';

import IdentityService from 'services/identity.service';
import ContactService from 'services/contact.service';
import mixpanel from 'mixpanel-browser';
import _ from 'lodash';

const appId  = '5ed154409db1725f766275df';
const widget  = '5f3bb8e6d7634a773207f88a';

function Result({ quiz, value, location }) {
  const dispatch = useDispatch();

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [title, setTitle] = useState('');
  const [company, setCompany] = useState('');
  const [email, setEmail] = useState('');

  const [errors, setErrors] = useState({});

  const formState = useSelector(state => state.application.form);
  const formSubmited = useSelector(state => state.application.form.submited);
  const formError = useSelector(state => state.application.form.error);
  const contact = useSelector(state => state.application.contact);

  const { url } = useRouteMatch();

  useEffect(() => {
    recordQuizScores();
  }, []);

  useEffect(() => {
    if(formState.token){
      ContactService.saveToken(appId, formState.token);

      window.parent.postMessage({
        action: 'QUIZ_LEAD_CAPTURED',
        payload: formState.token
      }, '*');

      recordQuizScores();
    }
  }, [formSubmited]);
  
  useEffect(() => {
    if(!formError){
      return;
    }

    if (Object.keys(formError).length > 0) {
      var errors = {};

      Object.keys(formError).forEach(id => {
        if(id === '5f3bb8e6d7634a773207f88d'){
          errors.email = formError[id];
        }
      });

      setErrors(errors);
    }
  }, [formError]);
  

  var score = 0;
  Object.keys(value.answers).forEach(key => {
    score = score + value.answers[key];
  });

  var result = quiz.results.find(item => {
    return item.score === score;
  });


  const updateAssessmentUrl = () => {
    var score = '';
    Object.keys(value.answers).forEach(key => {
      score = score + value.answers[key];
    });

    const url = `${quiz.url}?report=${score}&_=${new Date().getTime()}`;
    return url;
  }

  const handleFormSubmission = () => {
    const errors = validateForm();

    if (Object.keys(errors).length > 0) {
      setErrors(errors);

      return;
    }

    var request = {
      fields: [{
        id: '5f3bb8e6d7634a773207f88d',  //Email
        value: email
      },{
        id: '5f3cd39406db83773a7d428e',  //First Name
        value: firstName
      },{
        id: '5f3cd396fc81b55a1c2730ef',  //Last Name
        value: lastName
      },{
        id: '5f4a477d680261336ab713c9',  //Title
        value: title
      },{
        id: '5f3cd39706db83773a7d428f',  //Company
        value: company
      }]
    }

    dispatch(submitContactForm(appId, widget, request));
    if(email){
      mixpanel.identify(email);
      mixpanel.people.set({
        "$email": email
      });
    }
  }

  const validateForm = () => {
    var errors = {};
    if (!firstName || firstName.trim() === '') {
      errors['firstName'] = 'Please provide a valid name';
    }

    if (!email || email.trim() === '') {
      errors.email = "Please provide a valid email id"
    }

    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!regex.test(email)) {
      errors.email = "Please provide a valid email id";
    }

    if (!company || company.trim() === '') {
      errors.company = 'Please provide a valid company name';
    }
    
    return errors;
  }

  const recordQuizScores = () => {
    var score = '';
    const visitor = IdentityService.getFingerprint();
    Object.keys(value.answers).forEach(key => {
      score = score + value.answers[key];
    });
    
    const type = url === '/manager' ? 'manager' : 'rep';

    mixpanel.track("Quiz Finished", {
      "type": type,
      "visitor": visitor,
      "score": score
    });

    if(!contact){
      return;
    }

    const email = contact.email;
    const request = {
      email: email,
      type: type,
      score: score
    }

    dispatch(recordQuizResult(request));

    mixpanel.track("Quiz Form Submitted", {
      "type": type,
      "visitor": visitor,
      "score": score,
      "firstName": _.get(contact, 'firstName', ''),
      "lastName": _.get(contact, 'lastName', ''),
      "email": _.get(contact, 'email', ''),
      "company": _.get(contact, 'company', ''),
      "title": _.get(contact, 'title', ''),
    });
    
    if(email){
      mixpanel.identify(email);
      mixpanel.people.set({
        "$email": email
      });
    }
  }

  const assessmentUrl = updateAssessmentUrl();

  return (
    <div className={styles.result}>
      <Grid stackable columns={2}>
        <Grid.Column verticalAlign='middle'>
          <Segment basic padded='very'>
            <Header as='h1'>{result.header}</Header>
            <p className={styles.message}>{result.message}</p>
          </Segment>
        </Grid.Column>
        <Grid.Column>
          <video src={result.media} autoPlay playsInline loop />
        </Grid.Column>
      </Grid>

      {!contact &&
        <Grid centered>
          <Grid.Column computer={8} mobile={16}>
            <Segment basic className={styles.gating} textAlign='center'>
              <p className={styles.message}>Curious to know how we arrived at these scores? Get your personalized recommendations.</p>
              <Form onSubmit={handleFormSubmission}>
                <Form.Group widths='equal'>
                  <Form.Field>
                    <label>First name</label>
                    <Input type='text'
                      placeholder='First name' 
                      value={firstName}
                      onChange={(e) => { setFirstName(e.target.value) }} 
                    />
                    {errors.firstName && 
                      <span className={styles.error}>{errors.firstName}</span>
                    }
                  </Form.Field>
                  <Form.Field>
                    <label>Last name</label>
                    <Input type='text'
                      placeholder='Last name' 
                      value={lastName}
                      onChange={(e) => { setLastName(e.target.value) }} 
                    />
                    {errors.lastName && 
                      <span className={styles.error}>{errors.lastName}</span>
                    }
                  </Form.Field>
                </Form.Group>
                <Form.Group widths='equal'>
                  <Form.Field>
                    <label>Job Title</label>
                    <Input type='text'
                      placeholder='Job Title' 
                      value={title}
                      onChange={(e) => { setTitle(e.target.value) }} 
                    />
                    {errors.title && 
                      <span className={styles.error}>{errors.title}</span>
                    }
                  </Form.Field>
                </Form.Group>
                <Form.Group widths='equal'>
                  <Form.Field>
                    <label>Company</label>
                    <Input type='text'
                      placeholder='Company' 
                      value={company}
                      onChange={(e) => { setCompany(e.target.value) }} 
                    />
                    {errors.company && 
                      <span className={styles.error}>{errors.company}</span>
                    }
                  </Form.Field>
                </Form.Group>
                <Form.Group widths='equal'>
                  <Form.Field>
                    <label>Email</label>
                    <Input type='text'
                      placeholder='Email' 
                      value={email}
                      onChange={(e) => { setEmail(e.target.value) }}
                    />
                    {errors.email && 
                      <span className={styles.error}>{errors.email}</span>
                    }
                  </Form.Field>
                </Form.Group>
                <Form.Button disabled={formState.submiting} size='large'>{formState.submiting ? 'Processing...' : 'Let’s go!'}</Form.Button>
              </Form>
            </Segment>
          </Grid.Column>
        </Grid>
      }

      {contact &&
        <Segment basic className={styles.assessment} textAlign='center'>
          <p className={styles.message}>Thank you for the information. Here is your detailed report with recommendations.</p>
          <Button as="a" href={assessmentUrl} target="_blank" size='large'>View Assessment Report</Button>
        </Segment>
      }
    </div>
  );
}

export default Result;
